// src/context/CarContext.js

import React, { createContext, useState, useEffect } from 'react';
import { fetchCars } from '../shared/carService'; // Import the fetchCars service

// Create a Context for Cars
const CarContext = createContext();

export const CarProvider = ({ children }) => {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch cars data on mount
  useEffect(() => {
    fetchCars()
      .then((data) => {
        setCars(data);  // Set the car data into the state
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching car data:', error);
        setLoading(false);
      });
  }, []);  // This runs once when the component is mounted

  return (
    <CarContext.Provider value={{ cars, loading }}>
      {children}
    </CarContext.Provider>
  );
};

export default CarContext;
